import { gql } from 'apollo-boost';

export const GET_ADMIN_MCP_USAGE_STATS = gql`
    query GetAdminMcpUsageStats($data: AdminMcpUsageStatsInput) {
        getAdminMcpUsageStats(data: $data) {
            totalCalls
            successCount
            errorCount
            activeUsers
            activeTokens
            connectionEvents
            connectedUsers
            connectedTokens
            operations {
                operationName
                toolName
                count
                successCount
                errorCount
                avgDurationMs
            }
            users {
                userId
                tokenFingerprint
                count
                lastUsedAt
            }
            connectionEventCounts {
                eventType
                count
            }
            connectionClients {
                clientId
                clientName
                count
                connectedCount
                tokenRotatedCount
                lastEventAt
            }
            recentConnections {
                userId
                tokenFingerprint
                clientId
                clientName
                eventType
                scopes
                createdAt
            }
        }
    }
`;
